<script setup>
/**
 * Multiselect — UI proxy for vue-multiselect.
 *
 * Forwards v-model and all props/attrs to VueMultiselect with sensible defaults.
 * Add more explicit props here as needed; everything else passes through via $attrs.
 *
 * Usage:
 *   <Multiselect v-model="value" :options="list" label="name" track-by="name" />
 */
import VueMultiselect from 'vue-multiselect';

defineProps({
    modelValue: { default: null },
    options:    { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue', 'input']);

function onInput(value) {
    emit('update:modelValue', value);
    emit('input', value);
}
</script>

<template>
    <VueMultiselect
        :value="modelValue"
        :options="options"
        class="multiselect-mid pl-2"
        select-label=""
        deselect-label=""
        label="name"
        track-by="name"
        v-bind="$attrs"
        @input="onInput"
    />
</template>
